import WebService from "./WebService";

class SecurityService extends WebService {
  login(credentials, dataCallback, failureCallback) {
    const url = this.urlFactory.loginUrl();
    return this.post(
      url,
      credentials,
      dataCallback,
      undefined,
      failureCallback
    );
  }

  logout(callback) {
    const url = this.urlFactory.logoutUrl();
    return this.post(url, undefined, callback, this.blankSuccessCallback);
  }

  register(data, dataCallback, failureCallback) {
    const url = this.urlFactory.registerUrl();
    return this.post(url, data, dataCallback, undefined, failureCallback);
  }

  getPasswordRequirements(authenticationType, callback, failureCallback) {
    const urlParams = this.urlFactory.constructPasswordRequirementsQuery(
      authenticationType
    );
    const url = this.urlFactory.passwordRequirementsUrl() + urlParams;
    return this.get(url, callback, undefined, failureCallback);
  }

  checkUsername(authenticationType, username, callback, failureCallback) {
    const urlParams = this.urlFactory.constructCheckUsernameQuery(
      authenticationType,
      username
    );
    const url = this.urlFactory.checkUsernameUrl() + urlParams;
    return this.get(url, callback, this.blankSuccessCallback, failureCallback);
  }

  checkEmail(authenticationType, email, callback, failureCallback) {
    const urlParams = this.urlFactory.constructCheckEmailQuery(
      authenticationType,
      email
    );
    const url = this.urlFactory.checkEmailUrl() + urlParams;
    return this.get(url, callback, this.blankSuccessCallback, failureCallback);
  }
}

export default SecurityService;
